/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateSiteMiscSettingRequestSiteMiscSetting,
  UpdateSiteMiscSettingRequestSiteMiscSettingFromJSON,
  UpdateSiteMiscSettingRequestSiteMiscSettingFromJSONTyped,
  UpdateSiteMiscSettingRequestSiteMiscSettingToJSON
} from './UpdateSiteMiscSettingRequestSiteMiscSetting'

/**
 *
 * @export
 * @interface UpdateSiteMiscSettingRequest
 */
export interface UpdateSiteMiscSettingRequest {
  /**
   *
   * @type {UpdateSiteMiscSettingRequestSiteMiscSetting}
   * @memberof UpdateSiteMiscSettingRequest
   */
  siteMiscSetting?: UpdateSiteMiscSettingRequestSiteMiscSetting
}

export function UpdateSiteMiscSettingRequestFromJSON(json: any): UpdateSiteMiscSettingRequest {
  return UpdateSiteMiscSettingRequestFromJSONTyped(json, false)
}

export function UpdateSiteMiscSettingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSiteMiscSettingRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    siteMiscSetting: !exists(json, 'site_misc_setting')
      ? undefined
      : UpdateSiteMiscSettingRequestSiteMiscSettingFromJSON(json['site_misc_setting'])
  }
}

export function UpdateSiteMiscSettingRequestToJSON(value?: UpdateSiteMiscSettingRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    site_misc_setting: UpdateSiteMiscSettingRequestSiteMiscSettingToJSON(value.siteMiscSetting)
  }
}
